export const homeRoutePaths = {
  home: {
    path: '/',
    fullPath: '/',
  },
};
